import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'

type Props = {
  to?: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
}) => {
  const {pathname} = useLocation()
  const rawTo = typeof to === 'string' ? to.trim() : ''
  const isValidRoute = Boolean(rawTo && rawTo !== '#' && rawTo !== '-')
  const formattedTo = isValidRoute ? (rawTo.startsWith('/') ? rawTo : `/${rawTo}`) : ''
  const isActive = Boolean(formattedTo && checkIsActive(pathname, formattedTo))
  const {config} = useLayout()
  const {app} = config

  const linkContent = (
    <>
      {hasBullet && (
        <span className='menu-bullet'>
          <span className='bullet bullet-dot'></span>
        </span>
      )}
      {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
        <span className='menu-icon'>
          <KTIcon iconName={icon} className='fs-2' />
        </span>
      )}
      {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
        <i className={clsx('bi fs-3', fontIcon)}></i>
      )}
      <span className='menu-title'>{title}</span>
    </>
  )

  return (
    <div className='menu-item'>
      {isValidRoute ? (
        <Link className={clsx('menu-link without-sub', {active: isActive})} to={formattedTo}>
          {linkContent}
        </Link>
      ) : (
        <span className={clsx('menu-link without-sub', {active: isActive})}>
          {linkContent}
        </span>
      )}
      {children}
    </div>
  )
}

export {SidebarMenuItem}
